export default function loadGoogleMaps(apiKey) {
    return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
            resolve(window.google.maps);
            return;
        }

        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry`;
        script.async = true;
        script.defer = true;

        script.addEventListener('load', () => {
            resolve(window.google.maps);
        });

        script.addEventListener('error', () => {
            reject(new Error('Failed to load Google Maps'));
        });

        document.head.appendChild(script);
    });
}